import { render, staticRenderFns } from "./InfographyTips.vue?vue&type=template&id=7310b5be&"
import script from "./InfographyTips.vue?vue&type=script&lang=ts&"
export * from "./InfographyTips.vue?vue&type=script&lang=ts&"
import style0 from "./InfographyTips.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports